import { AbstractControl, UntypedFormArray, UntypedFormControl, ValidationErrors } from '@angular/forms';

export const IsControlRequired: (control: UntypedFormControl | UntypedFormArray) => boolean = (
    control: UntypedFormControl | UntypedFormArray
): boolean => {
    const validators: false | ValidationErrors | null =
        control && control.validator ? control.validator({} as AbstractControl) : false;

    if (!validators) {
        return false;
    }

    return validators.required;
};
